import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import _find from 'lodash/find';
import {
  useConfiguratorStore, useProductDataStore,
  useProductInfoStore
} from '../../../store';
import { useDesignStore } from '../../../store/design/context';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { deleteQueryParam } from '../../../utils/queryParams';
import { checkFulfillment } from '../../../utils/fulfillment-utils';
import { getSpan } from '../../Visualizer/utils';
import { NEW_RELIC_EVENTS } from '../../../constants';

const PipPersistLoader = ({ pipOmsId, ready, zipCode }) => {
  const products = useDesignStore((state) => state.design.products);
  const addProduct = useDesignStore((state) => state.add);
  const setIsFromPip = useDesignStore((state) => state.setIsFromPip);
  const configurator = useConfiguratorStore((state) => state.configurator);
  const productData = useProductDataStore((state) => state.productData);
  const productInfo = useProductInfoStore((state) => state.productInfo);
  const isFromPip = true;

  useEffect(() => {
    if (!productInfo?.packoutPipPersist) {
      return deleteQueryParam('pipOmsId');
    }
    const lookup = pipOmsId && ready && _isEmpty(products) && !_isEmpty(configurator?.metadata);
    if (lookup) {
      const choiceInfo = _find(configurator?.metadata, (data) => data?.metadata?.Sku === pipOmsId);
      const hasFulfillment = productData?.[pipOmsId].fulfillment.fulfillmentOptions;
      const fulfillmentInfo = checkFulfillment(productData?.[pipOmsId], zipCode);
      const isAvailable = productData?.[pipOmsId]
        ? _some(
          fulfillmentInfo,
          (info) => _some(
          info?.services,
          (service) => service.fulfillable === true
          )
        )
        : false;

      logNewRelicCustom(
        NEW_RELIC_EVENTS.PIP_TO_CALLOUT,
        {
          ...configurator.metadata[choiceInfo.choiceId].metadata,
          choiceId: choiceInfo.choiceId
        }
      );

      if (!isAvailable) {
        return deleteQueryParam('pipOmsId');
      }
      if (choiceInfo?.choiceId && hasFulfillment) {
        const [, , tubes] = getSpan(configurator.metadata[choiceInfo.choiceId].metadata.GridSpan);
        addProduct(choiceInfo.choiceId, configurator.metadata[choiceInfo.choiceId]?.metadata, [0, 0, tubes]);
        setIsFromPip(isFromPip);
        logNewRelicCustom(
          NEW_RELIC_EVENTS.PIP_PERSIST_ADD,
          {
            ...configurator.metadata[choiceInfo.choiceId].metadata,
            choiceId: choiceInfo.choiceId
          }
        );
        return deleteQueryParam('pipOmsId');
      }
    }

    return deleteQueryParam('pipOmsId');
  }, [ready]);

  return (<div id="pip-persist-loader" />);
};

PipPersistLoader.propTypes = {
  pipOmsId: string,
  ready: bool,
  zipCode: string,
};

PipPersistLoader.defaultProps = {
  pipOmsId: null,
  ready: false,
  zipCode: string,
};

export default PipPersistLoader;
